define(function (require) {
    var $ = require("jquery");
    var util = require("@modules/utils");
    var querystring = require("querystring");
    var tracker = require("@modules/interactiontracker/interactionTracker");
    var customInputMasks = require("@modules/inputmask/customInputMasks");
    var dataLayerService = require("@modules/services/dataLayerService");
    var isImpersonationMode = false;
    window.scan = window.scan || {};
    window.scan.editMember = window.scan.editMember || {};
    window.scan.editMember.smsElementClicked = null;

    function displayModal(elementId) {
        var options = {};
        // new Bootstrap 5 version of modal is instantiated differently than in the past::
        var myModal = new bootstrap.Modal(document.getElementById(elementId), options);
        myModal.show();
    }

    function highlightEditMemberFields() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $("span.field-validation-error:visible").each(function (index, element) {
            $(element).parent().parent().addClass("is-error");
            $(element).parent().addClass("is-error");
            $(element).parent(".form-item-group").parent().addClass("is-error");
            $(element).parent().parent().find("span.filter-option").addClass("is-error");
            $(element).parent().find("input").attr("aria-labelledby", $(element).attr("id")).attr("aria-invalid", "true");
            $(element).parent().find("div.btn-group").find("select").attr("aria-labelledby", $(element).attr("id")).attr("aria-invalid", "true");
        });
    }

    function undoEditMemberFieldHighlights() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class For Id
        $("span.field-validation-error").each(function (index, element) {
            $(element).parent().parent().removeClass("is-error");
            $(element).parent().removeClass("is-error");
            $(element).parent(".form-item-group").parent().removeClass("is-error");
            $(element).parent().parent().find("span.filter-option").removeClass("is-error");
            $(element).parent().find("input").attr("aria-labelledby", $(element).parent().parent().find("label").attr("id")).attr("aria-invalid", "false");
            $(element).parent().find("div.btn-group").find("select").attr("aria-labelledby", $(element).parent().parent().find("label").attr("id")).attr("aria-invalid", "false");
        });
    }

    undoEditMemberFieldHighlights();
    highlightEditMemberFields();

    $(document).ready(function () {
        $("div.form-item")
            .find("input")
            .each(function (index, element) {
                var labelId = $(element).parent().parent().find("label").attr("id");
                $(element).attr("aria-labelledby", labelId);
            });

        $("div.form-item")
            .find("select")
            .each(function (index, element) {
                var labelId = $(element).parent().parent().find("label").attr("id");
                $(element).attr("aria-labelledby", labelId);
            });

        if ($(".impersonation-header").length > 0) {
            isImpersonationMode = true;
        }

        if (!isImpersonationMode) {
            $(".communications-options")
                .find('input[data-bs-target="#mobileNumberModal"]')
                .each(function (index, element) {
                    $(element).removeAttr("disabled");
                });
        }

        if ($("#updateAddress").find(".alert").length > 0) {
            expandPanel("#updateAddress");
        }

        //updateEmergencyContact

        if ($("#updateEmergencyContact").find(".alert").length > 0 || $("#updateEmergencyContact").find(".validation-summary-errors").length > 0) {
            expandPanel("#updateEmergencyContact");
        }

        // member reg dob input mask
        var memberDOB = $("#memberDOB");
        if (memberDOB.length > 0) {
            customInputMasks.bindCustomDateInputMask(memberDOB);
        }

        if ($("#updatePrimaryType").val() == "Mobile" && $("#updateNonPrimaryType").val() == "Mobile") {
            $(".smsnote").show();
        }
    });

    function expandPanel(panelRef) {
        $(panelRef).addClass("show");
        $(panelRef).css("height", "initial");
    }

    function clearValidationSummary() {
        $("div.validation-summary-errors").remove();
    }

    function createValidationSummary(formId, errorMessageCount, tagName) {
        $("div.validation-summary-errors").remove();
        var errorMessages = $("span.field-validation-error:visible")
            .map(function () {
                return $.trim($(this).text());
            })
            .get();

        var valueToRemove = "";

        errorMessages = $.grep(errorMessages, function (value) {
            return value !== valueToRemove;
        });

        errorMessageCount = errorMessageCount || $(errorMessages).length;
        if (errorMessageCount == 0) {
            return;
        }
        tagName = tagName || "form";

        var $form = $("#" + formId);
        var listHtml = "";
        $form.prepend("<div id='javascriptValidationSummary' class='validation-summary-errors form-error-text'>");

        listHtml += "<strong id='javascriptValidationCount' class='form-error-text'>" + errorMessageCount + " " + $(".hidden.validation-error-count").html() + "</strong>";
        listHtml += "<ul id='javascriptValidationUl'>";
        $(errorMessages).each(function (index, element) {
            listHtml += "<li>" + element + "</li>";
        });
        listHtml += "</ul>";
        $(listHtml).appendTo("#javascriptValidationSummary");
    }

    function createCaregiverObject(isForRemoval, element) {
        var caregiversToRemove = [];
        var newCaregivers = [];

        var confirmEmail = $(element).find("[id^=confirm-caregiver-email]:visible");

        var caregiverForJson = new Object();
        var firstName = $(element).find("[id^=caregiver-first-name]");
        var lastName = $(element).find("[id^=caregiver-last-name]");
        var email = $(element).find("[id^=caregiver-email]");
        caregiverForJson.FirstName = isForRemoval ? firstName.text() : firstName.val();
        caregiverForJson.FirstNameErrorId = $(element).find("[id^=firstNameError]").attr("id");
        caregiverForJson.LastName = isForRemoval ? lastName.text() : lastName.val();
        caregiverForJson.LastNameErrorId = $(element).find("[id^=lastNameError]").attr("id");
        caregiverForJson.Email = isForRemoval ? email.text() : email.val();
        caregiverForJson.EmailErrorId = $(element).find("[id^=emailError]").attr("id");
        caregiverForJson.EmailMismatchErrorId = $(element).find("[id^=emailMismatchError]").attr("id");
        caregiverForJson.ConfirmEmailMismatchErrorId = $(element).find("[id^=confirmEmailMismatchError]").attr("id");
        caregiverForJson.ConfirmEmail = null;

        if (confirmEmail.length > 0) {
            caregiverForJson.ConfirmEmail = confirmEmail.val();
            caregiverForJson.ConfirmEmailErrorId = $(element).find("[id^=confirmEmailError]").attr("id");
        }

        caregiverForJson.CaregiverInviteId = $(element).find(".caregiver-box-remove").attr("data-invite-id");
        caregiverForJson.AssociationId = $(element).find(".caregiver-box-remove").attr("data-association-id");
        caregiverForJson.Status = $(element).find(".caregiver-box-remove").attr("data-status");

        var password = $(element).find("[id=verify-password-caregiver]");
        caregiverForJson.Password = isForRemoval ? '' : password.val();

        if (isForRemoval) {
            caregiversToRemove.push(caregiverForJson);
        } else {
            newCaregivers.push(caregiverForJson);
        }

        var objectForJson = new Object();
        objectForJson.CaregiversToRemove = caregiversToRemove;
        objectForJson.NewCaregivers = newCaregivers;
        objectForJson.DataSourceId = $("#DataSourceId").val();

        return objectForJson;
    }

    $("#eDeliverySubmitButton").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();

        var edeliveryOption = $('input[name="EDeliveryOption"]:checked').length;

        if (edeliveryOption === 0) {
            $("#eDeliveryOptionError").show();
            highlightEditMemberFields();
            createValidationSummary("editEDeliveryForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        } else {
            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            $("form#editEDeliveryForm").submit();
        }
    });

    $("#securityQuestionSubmit").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();

        var isValid = true;

        $("span.field-validation-error.form-error-hint").hide();

        var question = $("#SecretQuestionKey").val();
        var answer = $("#answer").val();
        var confirmAnswer = $("#confirm-answer").val();

        if (!question) {
            isValid = false;
            $("#secretQuestionError").show();
        }

        if (!answer) {
            isValid = false;
            $("#secretAnswerError").show();
        }

        if (!confirmAnswer) {
            isValid = false;
            $("#confirmSecretAnswerError").show();
        }

        if (confirmAnswer && answer && $.trim(confirmAnswer) !== $.trim(answer)) {
            isValid = false;
            $("#secretAnswerMismatchError").show();
            $("#confirmSecretAnswerMismatchError").show();
        }

        var password = $("#verify-password-security-question").val();
        if ($.trim(password) == "") {
            isValid = false;
            $("#PasswordErrorMessageForSecurityQuestion").show();
        }

        if (isValid) {
            var dataLayerEvent = {
                event: "changeQuestion",
                "ctaLink": $(this).text().trim()
            };
            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);

            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            $("form#editSecurityQuestionForm").submit();
        } else {
            highlightEditMemberFields();
            createValidationSummary("editSecurityQuestionForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
    });

    $("#languagePreferencesSubmit").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();

        var isValid = true;

        $("span.field-validation-error.form-error-hint").hide();

        var writtenLanguagePreference = $("#SelectedWrittenLanguage").val();
        var spokenLanguagePreference = $("#SelectedSpokenLanguage").val();

        if (!writtenLanguagePreference) {
            isValid = false;
            $("#WrittenLanguageError").show();
        }

        if (!spokenLanguagePreference) {
            isValid = false;
            $("#SpokenLanguageError").show();
        }

        if (isValid) {
            var dataLayerEvent = {
                event: "setlanguage",
                "writtenLanguage": writtenLanguagePreference,
                "spokenLanguage": spokenLanguagePreference
            };
            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);

            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            $("form#editLanguagePreferencesForm").submit();
        } else {
            highlightEditMemberFields();
            createValidationSummary("editLanguagePreferencesForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
    });

    $("#requestIdCardSubmit").on("click", function (e) {
        e.preventDefault();
        $("#requestIdCardSubmit").hide();
        $("#requestIdCardSubmitDisabled").show();
        $("form#requestIdCardForm").submit();
    });

    $("#changePasswordSubmit").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();

        var isValid = true;

        $("span.field-validation-error.form-error-hint").hide();

        var currentpassword = $("#current-pass").val();
        var password = $("#new-pass").val();
        var confirmPassword = $("#confirm-pass").val();

        if (!util.isValidPassword(password)) {
            isValid = false;
            $("#passwordError").show();
        }

        if (!currentpassword) {
            isValid = false;
            $("#currentPasswordError").show();
        }

        if (!confirmPassword) {
            isValid = false;
            $("#confirmPasswordError").show();
        }

        if (util.showConfirmFieldError(password, confirmPassword)) {
            isValid = false;
            $("#passwordMismatchError").show();
            $("#confirmPasswordMismatchError").show();
        }
        if (isValid) {
            var dataLayerEvent = {
                event: "changePassword",
                "ctaLink": $(this).text().trim()
            };
            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);

            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            $("form#editPasswordForm").submit();
        } else {
            highlightEditMemberFields();
            createValidationSummary("editPasswordForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
    });

    $("#changeFirstTimePasswordSubmit").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();

        var isValid = true;

        $("span.field-validation-error.form-error-hint").hide();

        var password = $("#new-pass").val();
        var confirmPassword = $("#confirm-pass").val();

        if (!util.isValidPassword(password)) {
            isValid = false;
            $("#passwordError").show();
        }

        if (!confirmPassword) {
            isValid = false;
            $("#confirmPasswordError").show();
        }

        if (util.showConfirmFieldError(password, confirmPassword)) {
            isValid = false;
            $("#passwordMismatchError").show();
            $("#confirmPasswordMismatchError").show();
        }
        if (isValid) {
            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            $("form#editPasswordForm").submit();
        } else {
            highlightEditMemberFields();
            createValidationSummary("editPasswordForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
    });

    $("#emailEditSubmit").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();

        var isValid = true;
        $("span.field-validation-error.form-error-hint").hide();

        var email = $("#new-email").val();
        var confirmEmail = $("#confirm-email").val();
        var emailMaxLength = $("#new-email-maxlength").val();

        if (!util.isValidEmail(email)) {
            isValid = false;
            $("#emailError").show();
        }

        if (!util.isValidEmailLength(email, emailMaxLength)) {
            isValid = false;
            $("#emailMaxLengthError").show();
        }

        if (!confirmEmail) {
            isValid = false;
            $("#confirmEmailError").show();
        }

        if (email && confirmEmail && $.trim(email) !== $.trim(confirmEmail)) {
            isValid = false;
            $("#emailMismatchError").show();
            $("#confirmEmailMismatchError").show();
        }

        var password = $("#verify-password-email").val();
        if ($.trim(password) == "") {
            isValid = false;
            $("#PasswordErrorMessageForEmail").show();
        }
        else {
            $("#PasswordErrorMessageForEmail").hide();
        }

        if (isValid) {
            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            tracker.RecordGoalFn("interaction-updateemail");
            $("form#editEmailForm").submit();
        } else {
            highlightEditMemberFields();
            createValidationSummary("editEmailForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
    });

    $("#editEmergencyContactSubmit").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();
        var emergencyContactPhone = $("#emergencyContactPhone").val();
        var emergencyContactName = $("#emergencyContactName").val();

        var isValid = true;
        $("span.field-validation-error.form-error-hint").hide();

        // phone is not required so only check validity if not empty
        if (emergencyContactPhone != "") {
            // require name if phone is provided
            if (emergencyContactName == "") {
                isValid = false;
                $("#EmergencyContactNameRequired").show();
            } else {
                $("#EmergencyContactNameRequired").hide();
            }
            if (!util.isValidPhone(emergencyContactPhone)) {
                isValid = false;
                $("#PhoneNumberFormatText").show();
            } else {
                $("#PhoneNumberFormatText").hide();
            }
        }

        if (isValid) {
            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            $("form#editEmergencyContactForm").submit();
        } else {
            highlightEditMemberFields();
            createValidationSummary("editEmergencyContactForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
    });

    $("#caregiverMemberEmailEditSubmit").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();

        var isValid = true;
        $("span.field-validation-error.form-error-hint").hide();

        var email = $("#cgnew-email").val();
        var confirmEmail = $("#cgconfirm-email").val();
        var emailMaxLength = $("#cgnew-email-maxlength").val();

        if (!util.isValidEmail(email)) {
            isValid = false;
            $("#cgemailError").show();
        }

        if (!util.isValidEmailLength(email, emailMaxLength)) {
            isValid = false;
            $("#cgemailMaxLengthError").show();
        }

        if (!confirmEmail) {
            isValid = false;
            $("#cgconfirmEmailError").show();
        }

        if (email && confirmEmail && $.trim(email) !== $.trim(confirmEmail)) {
            isValid = false;
            $("#cgemailMismatchError").show();
            $("#cgconfirmEmailMismatchError").show();
        }

        if (isValid) {
            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            $("form#caregiverMemberEditEmailForm").submit();
        } else {
            highlightEditMemberFields();
            createValidationSummary("caregiverMemberEditEmailForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
    });

    $("input[data-sms=true]").on("click", function (e) {
        window.scan.editMember.smsElementClicked = this;
        if ($(this).is(":checked")) {
            $(this).attr("data-bs-target", "#mobileNumberModal").attr("data-bs-toggle", "modal");
            $(this).prop("checked", false);
        }
        $(".tcpa-label").removeClass("error");
        $(".msamtcpa-label").removeClass("error");
        $("#tcpagreement").prop("checked", false);
        $("#msamtcpagreement").prop("checked", false);
        $("#TCPAConsentNotCheckedText").hide();
        $("#MsamTCPAConsentNotCheckedText").hide();
        $("#phoneEditSubmit,#adminphoneEditSubmit").prop("disabled", false);
        $(".sms-preference-name").text($(this).attr("data-communication-name"));
    });

    $("#saveTcpa").on("click", function (e) {
        var isOnCommPrefs = window.scan.commpreference != null;
        if (isOnCommPrefs) {
            // if we're on the comm prefs page and a mobile number has been added via the
            // modal dialog, disable the modal dialog trigger on all the checkboxes - we
            // don't need the modal any more
            if (!$("#tcpagreement").is(":checked")) {
                $(".tcpa-label").addClass("error");
                $("#TCPAConsentNotCheckedText").show();
            } else {
                $(".tcpa-label").removeClass("error");
                $("#TCPAConsentNotCheckedText").hide();
            }
            if (!$("#msamtcpagreement").is(":checked")) {
                $(".msamtcpa-label").addClass("error");
                $("#MsamTCPAConsentNotCheckedText").show();
            } else {
                $(".msamtcpa-label").removeClass("error");
                $("#MsamTCPAConsentNotCheckedText").hide();
            }
            if (!$("#tcpagreement").is(":checked") || ($("#msamtcpagreement").length && !$("#msamtcpagreement").is(":checked"))) {
                return false;
            }

            $("#mobileNumberModal").modal("hide");
            if ($("#tcpagreement").is(":checked")) {
                // also, find the checkbox that triggered the modal and make sure it is now checked
                $("#tcpagreement").prop("checked", false);
                $("#msamtcpagreement").prop("checked", false);
                if (window.scan.editMember.smsElementClicked != null) {
                    $(window.scan.editMember.smsElementClicked).prop("checked", true);
                    $(window.scan.editMember.smsElementClicked).removeData("target").removeAttr("data-bs-target").removeAttr("data-bs-toggle");
                    window.scan.editMember.smsElementClicked = null;
                }
            }
        }
    });

    $("#updatePrimaryType, #updateNonPrimaryType").change(function () {
        if ($("#updatePrimaryType").val() == "Mobile" && $("#updateNonPrimaryType").val() == "Mobile") {
            $(".smsnote").show();
        } else {
            $(".smsnote").hide();
        }
    });

    $("#phoneEditSubmit,#adminphoneEditSubmit").on("click", function (e) {
        var formId = window.scan.editPhone.formId;
        var $button = $(this);
        var $form = $("#" + formId);
        var isOnCommPrefs = window.scan.commpreference != null;
        var isInMSAM = window.scan.memberservices != null;
        var isAdminForm = $button.attr("id") == "adminphoneEditSubmit";

        var isErrored = function () {
            var isError = $form.find("span.field-validation-error:visible").length > 0;

            if (isError) {
                highlightEditMemberFields();
                createValidationSummary(formId, null, "div");
            }

            return isError;
        };

        // function for displaying result message from form submission;
        // specific to phone edit form, but may be pulled out for use
        // elsewhere eventually.

        var createResultMessage = function () {
            $("div.validation-summary-errors").remove();

            var errorMessages = $("span.form-submission-message.active")
                .map(function () {
                    return $.trim($(this).text());
                })
                .get();
            var valueToRemove = "";

            errorMessages = $.grep(errorMessages, function (value) {
                return value !== valueToRemove;
            });

            var listHtml = "";

            $form.prepend("<div id='javascriptValidationSummary' class='validation-summary-errors form-error-text'>");

            listHtml += "<ul id='javascriptValidationUl'>";
            $(errorMessages).each(function (index, element) {
                listHtml += "<li>" + element + "</li>";
            });
            listHtml += "</ul>";
            $(listHtml).appendTo("#javascriptValidationSummary");
        };

        //Phone1TypeInvalid
        var $phone1ValField = $form.find("[id*=phoneNumber1Field]");
        var $origPhone1Values = $form.find("[id*=orginalPhoneNumber1Values]");
        var $phone2ValField = $form.find("[id*=phoneNumber2Field]");
        var $origPhone2Values = $form.find("[id*=orginalPhoneNumber2Values]");
        var $phone1TypeField = $form.find("#updatePrimaryType");
        var $phone2TypeField = $form.find("#updateNonPrimaryType");
        var $phone1RequiredMessage = $("#PhoneNumberInvalidText");
        var $phone1InvalidMessage = $("#NoPhoneNumberEnteredText");
        var $phone1NoMobileMessage = $("#NoMobileNumberText"); //
        var $phone1PrimaryMessage = $("#NoPhoneNumberPrimaryText");
        var $phone1TypeInvalidMessage = $("#PhoneNumber1TypeValue");
        var $phone2RequiredMessage = $("#PhoneNumber2InvalidText"); //
        var $phone2InvalidMessage = $("#NoPhoneNumber2EnteredText"); //
        var $phone2PrimaryMessage = $("#NoPhoneNumber2PrimaryText"); //
        var $phone2NoMobileMessage = $("#NoMobileNumber2Text");
        var $phone2TypeInvalidMessage = $("#PhoneNumber2TypeValue"); //
        var phone1FieldVal = $phone1ValField.val().trim();
        var origPhone1FieldVal = $origPhone1Values.length > 0 ? $origPhone1Values.val().trim() : "";
        var phone2FieldVal = $phone2ValField.val().trim();
        var origPhone2FieldVal = $origPhone2Values.length > 0 ? $origPhone2Values.val().trim() : "";
        var phone1TypeVal = $phone1TypeField.val().trim();
        var phone2TypeVal = $phone2TypeField.val().trim();
        var phone1TypeText = phone1TypeVal !== "" ? $form.find("#updatePrimaryType option:selected").text().trim() : "";
        var phone2TypeText = phone2TypeVal !== "" ? $form.find("#updateNonPrimaryType option:selected").text().trim() : "";
        var phonePrimaryVal = $("[name=PrimaryPhone]:radio:checked").val();
        var isPhone1Primary = $("[name=PrimaryPhone]:radio:checked").val() == "phone1" && phone1TypeVal == "Mobile";
        var isPhone2Primary = $("[name=PrimaryPhone]:radio:checked").val() == "phone2" && phone2TypeVal == "Mobile";

        $button.prop("disabled", true);
        clearValidationSummary();
        undoEditMemberFieldHighlights();
        $form.find("span.field-validation-error").hide();
        $form.find("span.form-submission-message").removeClass("active");

        // first let's validate

        $phone1RequiredMessage.toggle(phone1FieldVal === "" && phone2FieldVal === "");

        var isphone1TypeValMobile = phone1TypeVal == "Mobile";
        var isphone2TypeValMobile = phone2TypeVal == "Mobile";
        var isPhone1FieldValChanged = phone1FieldVal + "|" + phone1TypeVal != origPhone1FieldVal;
        var isPhone2FieldValChanged = phone2FieldVal + "|" + phone2TypeVal != origPhone2FieldVal;
        var isUpdateFormHidden = !$(".updatePhoneForm").is(":visible");
        var hasPrimaryMobileTypeChanged = phone1TypeVal != origPhone1FieldVal.split("|")[1] && isphone2TypeValMobile;
        var hasPrimarySelectionChanged = !isPhone1FieldValChanged && !isPhone2FieldValChanged && isPhone2Primary && isphone1TypeValMobile;

        if (isErrored()) {
            $button.prop("disabled", false);
            return false;
        }

        $phone1InvalidMessage.toggle(phone1FieldVal !== "" && !util.isValidPhone(phone1FieldVal));
        $phone2InvalidMessage.toggle(phone2FieldVal !== "" && !util.isValidPhone(phone2FieldVal));
        var hasPhone1 = phone1FieldVal !== "";
        var hasPhone2 = phone2FieldVal !== "";

        $phone1TypeInvalidMessage.toggle(hasPhone1 && phone1TypeVal === "");
        $phone2TypeInvalidMessage.toggle(hasPhone2 && phone2TypeVal === "");

        if (isOnCommPrefs) {
            if (hasPhone1 && phone1TypeVal !== "Mobile" && !hasPhone2) $phone1NoMobileMessage.show();
            if (hasPhone2 && phone2TypeVal !== "Mobile" && !hasPhone1) $phone2NoMobileMessage.show();
            if (hasPhone1 && hasPhone2 && phone1TypeVal !== "Mobile" && phone2TypeVal !== "Mobile") {
                $phone1NoMobileMessage.show();
                $phone2NoMobileMessage.show();
            }
        }

        if (isErrored()) {
            $button.prop("disabled", false);
            return false;
        }

        $phone1PrimaryMessage.toggle(phone1FieldVal === "" && phonePrimaryVal === "phone1");
        $phone2PrimaryMessage.toggle(phone2FieldVal === "" && phonePrimaryVal === "phone2");

        if (!$("#tcpagreement").is(":checked") && isOnCommPrefs) {
            $button.prop("disabled", false);
            $(".tcpa-label").addClass("error");
            $("#TCPAConsentNotCheckedText").show();
        } else {
            $(".tcpa-label").removeClass("error");
            $("#TCPAConsentNotCheckedText").hide();
        }

        if (!$("#msamtcpagreement").is(":checked")) {
            $(".msamtcpa-label").addClass("error");
            $("#MsamTCPAConsentNotCheckedText").show();
        } else {
            $(".msamtcpa-label").removeClass("error");
            $("#MsamTCPAConsentNotCheckedText").hide();
        }

        if ((!$("#tcpagreement").is(":checked") && isOnCommPrefs)
            || (!$("#msamtcpagreement").is(":checked") && $("#msamtcpagreement").length && isInMSAM)) {
            $button.prop("disabled", false);
            return false;
        }

        var passwordVal = "";
        if (!isInMSAM) {
            var $password = $form.find("[id=verify-password]");
            passwordVal = $password.val().trim();
            if (passwordVal === "") {
                $("#PasswordErrorMessage").show();
            }
            else {
                $("#PasswordErrorMessage").hide();
            }
        }

        if (isErrored()) {
            $button.prop("disabled", false);
            return false;
        }

        var commPreferencesLength = $(".preferences input:checkbox").length;
        var preferences = [];
        var origNumbers = [];
        origNumbers.push(origPhone1FieldVal.split("|"));
        origNumbers[0].push(hasPrimarySelectionChanged ? isPhone2Primary : isPhone1Primary);
        origNumbers.push(origPhone2FieldVal.split("|"));
        origNumbers[1].push(hasPrimarySelectionChanged ? isPhone1Primary : isPhone2Primary);

        var origPrimaryMobileNumberItem;

        if (
            origNumbers.filter(function (item) {
                return item[1] === "Mobile" && item[2] === true; // works if both numbers started out as mobile
            }).length > 0
        ) {
            origPrimaryMobileNumberItem = origNumbers.filter(function (item) {
                return item[1] === "Mobile" && item[2] === true; // works if both numbers started out as mobile
            });
        } else {
            origPrimaryMobileNumberItem = origNumbers.filter(function (item) {
                return item[1] === "Mobile"; // otherwise, grab the single mobile one
            });
        }

        var origMobileNumber = origPrimaryMobileNumberItem.length > 0 && origPrimaryMobileNumberItem[0].length > 1 ? origPrimaryMobileNumberItem[0][0] : "";

        if (commPreferencesLength > 0 && !isUpdateFormHidden && ((isphone1TypeValMobile && isPhone1FieldValChanged && !isPhone2Primary) || (isphone2TypeValMobile && isPhone2FieldValChanged && !isPhone1Primary) || hasPrimaryMobileTypeChanged || hasPrimarySelectionChanged)) {
            // $(".old-number").text((isphone1TypeValMobile && isPhone1FieldValChanged) || hasPrimaryMobileTypeChanged || hasPrimarySelectionChanged ? origPhone1FieldVal.split("|")[0] : origPhone2FieldVal.split("|")[0]);
            $(".old-number").text(origMobileNumber);

            $(".new-number").text(isphone1TypeValMobile && isPhone1FieldValChanged ? phone1FieldVal : phone2FieldVal);
            $(".preferences, .reconsent-title").show();
            $(".updatePhoneForm, .update-phone-title").hide();
            $button.prop("disabled", false);
            return false;
        }
        if ((isphone1TypeValMobile && isPhone1FieldValChanged && !isPhone2Primary) || (isphone2TypeValMobile && isPhone2FieldValChanged && !isPhone1Primary) || hasPrimaryMobileTypeChanged || hasPrimarySelectionChanged) {
            $(".preferences input:checkbox").each(function (index) {
                var commPreferences = {
                    ItemOption: $(this).attr("data-option"),
                    ItemValue: $(this).is(":checked"),
                    ItemType: $(this).attr("data-identifier"),
                    VendorBindingName: $(this).attr("data-vendorbindingname"),
                    CampaignId: $(this).attr("data-campaignid")
                };
                preferences.push(commPreferences);
            });
        }

        // validations passed, run the api call to update

        var updateParameters = {
            DataSourceId: $("#" + formId + "-DataSourceId").val(),
            TamperCheck: $("#" + formId + "-TamperCheck").val(),
            PhoneNumber1FieldValue: phone1FieldVal,
            PhoneNumber1TypeValue: phone1TypeVal,
            PhoneNumber2FieldValue: phone2FieldVal,
            PhoneNumber2TypeValue: phone2TypeVal,
            PrimaryPhone: phonePrimaryVal,
            OrigMobileNumber: origMobileNumber,
            CommPreferences: JSON.stringify(preferences),
            Password: passwordVal
        };

        if (isAdminForm) {
            updateParameters["AssociationId"] = $("input[name='AssociationID']").val();
            updateParameters["AccountId"] = $("input[name='AccountID']").val();
            updateParameters["MemberId"] = $("input[name='MemberID']").val();
        }

        var headers = {
            RequestVerificationToken: util.getRequestVerificationToken()
        };

        var errorCallback = function (xhr, status, errorText) {
            $form.find("span#" + formId + "-UpdateFailed").addClass("active");

            createResultMessage();
            $button.prop("disabled", false);
        };
        var successCallback = function (data, status, xhr) {
            var spanFilterPrefix = "span#" + formId + "-";
            $button.prop("disabled", false);
            switch (data) {
                case "UpdateSucceeded": {
                    if (phonePrimaryVal == "phone2") {
                        var phone1OldFieldVal = phone1FieldVal;
                        var phone1OldTypeVal = phone1TypeVal;
                        var phone1OldTypeText = phone1TypeText;

                        phone1FieldVal = phone2FieldVal;
                        phone1TypeVal = phone2TypeVal;
                        phone1TypeText = phone2TypeText;
                        phone2FieldVal = phone1OldFieldVal;
                        phone2TypeVal = phone1OldTypeVal;
                        phone2TypeText = phone1OldTypeText;
                    }

                    // trigger interaction tracker goal
                    tracker.RecordGoalFn("interaction-updatephonenumber");

                    var $primaryContainer = $("#your-information .phone-information-primary");
                    var $nonPrimaryContainer = $("#your-information .phone-information-nonprimary");
                    var primaryText = $("label[for=update-phone-1]").text(); // translated "primary" text
                    var phone1Text = util.formatPhoneString(phone1FieldVal);
                    var phone2Text = util.formatPhoneString(phone2FieldVal);

                    phone1Text += " • " + phone1TypeText + " • " + primaryText;
                    if (phone2FieldVal !== "") {
                        phone2Text += " • " + phone2TypeText;
                    }

                    $primaryContainer.text(phone1Text);
                    $nonPrimaryContainer.text(phone2Text);

                    $form.find(spanFilterPrefix + "UpdateSucceeded").addClass("active");

                    $(".preferences, .reconsent-title").hide();
                    $(".updatePhoneForm, .update-phone-title").show();
                    $button.prop("disabled", true);

                    if (isOnCommPrefs) {
                        // if we're on the comm prefs page and a mobile number has been added via the
                        // modal dialog, disable the modal dialog trigger on all the checkboxes - we
                        // don't need the modal any more

                        //var smsCheckboxes = $("input[type=checkbox]").filter(function () { return $(this).data("target") === "#mobileNumberModal"; });

                        //smsCheckboxes.removeData("target").removeAttr("data-bs-target").removeAttr("data-bs-toggle");

                        // also, find the checkbox that triggered the modal and make sure it is now checked
                        $(".communication-pref-modal").hide();
                        $(".communication-pref-modal.success").show();
                        if ($("#tcpagreement").is(":checked")) {
                            $("#mobileNumberModal").modal("hide");
                            clearValidationSummary();
                            $(".tcpa-label").removeClass("error");
                            $("#TCPAConsentNotCheckedText").hide();
                            // also, find the checkbox that triggered the modal and make sure it is now checked
                            $("#tcpagreement").prop("checked", false);
                            $(".your-mobile-number span").text(phone1TypeVal == "Mobile" ? phone1FieldVal : phone2FieldVal);
                            if (window.scan.editMember.smsElementClicked != null) {
                                $(window.scan.editMember.smsElementClicked).prop("checked", true);
                                $(window.scan.editMember.smsElementClicked).removeData("target").removeAttr("data-bs-target").removeAttr("data-bs-toggle");
                                window.scan.editMember.smsElementClicked = null;
                            }
                        }
                    }

                    break;
                }
                case "UpdateUnnecessary":
                    $form.find(spanFilterPrefix + "UpdateUnnecessary").addClass("active");
                    if ($("#tcpagreement").is(":checked")) {
                        $("#mobileNumberModal").modal("hide");
                        // also, find the checkbox that triggered the modal and make sure it is now checked
                        $("#tcpagreement").prop("checked", false);
                        if (window.scan.editMember.smsElementClicked != null) {
                            $(window.scan.editMember.smsElementClicked).prop("checked", true);
                            $(window.scan.editMember.smsElementClicked).removeData("target").removeAttr("data-bs-target").removeAttr("data-bs-toggle");
                            window.scan.editMember.smsElementClicked = null;
                        }
                    } else if (!$("#tcpagreement").is(":checked") && $(".communication-pref-modal.success:visible")) {
                        $("#mobileNumberModal").modal("hide");
                    }
                    break;
                case "SMSPreferenceConflict":
                    $form.find(spanFilterPrefix + "SMSPreferenceConflict").addClass("active");

                    break;
                case "Unauthorized":
                    $form.find(spanFilterPrefix + "InvalidPassword").addClass("active");
                    $form.find("#PasswordErrorMessage").html($form.find(spanFilterPrefix + "InvalidPassword").html());
                    $form.find("#PasswordErrorMessage").addClass("active");
                    $form.find("#PasswordErrorMessage").show();
                    break;
                default:
                    $form.find(spanFilterPrefix + "UpdateFailed").addClass("active");

                    break;
            }

            createResultMessage();
        };

        var ajaxUrl = isAdminForm ? "/api/adminphoneupdate/updatephones" : "/api/portalmemberupdate/updatephones";

        $.ajax({
            type: "POST",
            url: ajaxUrl,
            dataType: "json",
            data: updateParameters,
            headers: headers,
            success: successCallback,
            error: errorCallback
        });

        return true;
    });

    $("#addCaregiverButton").on("click", function (e) {
        e.preventDefault();

        var $newCaregiverHtml = $("#newCaregiverTemplate").clone();
        $newCaregiverHtml.find("div").first().parent().attr("id", "").show();
        $newCaregiverHtml.find("a.caregiver-box-remove").on("click", function (e1) {
            e1.preventDefault();

            var $linkClicked = $(e1.target);

            $linkClicked.parent().parent().remove();
        });

        var numCaregiverDivs = $("div.caregiver-box:visible").length;

        $newCaregiverHtml.find("input").each(function (index, element) {
            $(element).attr("id", $(element).attr("id") + "-" + numCaregiverDivs);
        });

        $newCaregiverHtml.find("div.form-item").each(function (index, element) {
            $(element).find("label").attr("for", $(element).find("input").attr("id"));
        });

        $newCaregiverHtml.find("span.field-validation-error").each(function (index, element) {
            $(element).attr("id", $(element).attr("id") + "-" + numCaregiverDivs);
        });

        $newCaregiverHtml.find("div").first().parent().addClass("valid-caregiver");

        $("div.caregiver-box.add-new").before($newCaregiverHtml);

        $(".caregiver-box.add-new").hide();
        $("#updateCaregiversButton").hide();
        $("#inviteNewCaregiverButton").show();
    });

    $("#inviteNewCaregiverButton").on("click", function (e) {
        e.preventDefault();
        undoEditMemberFieldHighlights();

        var isValid = true;
        $("span.field-validation-error.form-error-hint").hide();
        var element = $("div.caregiver-box.new-caregiver:visible");

        element = $("#editCaregiverForm");
        var password = $(element).find("[id=verify-password-caregiver]").val();
        if (!password || $.trim(password) === "") {
            isValid = false;
            $(element).find("[id=PasswordErrorMessageForCaregiver]").show();
        }

        var firstName = $(element).find("[id^=caregiver-first-name]").val();
        var lastName = $(element).find("[id^=caregiver-last-name]").val();
        var email = $(element).find("[id^=caregiver-email]").val();
        var confirmEmail = $(element).find("[id^=confirm-caregiver-email]:visible");
        var emailMaxLength = $("#caregiver-email-maxlength").val();

        if (!firstName || $.trim(firstName) === "") {
            isValid = false;
            $(element).find("[id^=firstNameError]").show();
        }

        if (!lastName || $.trim(lastName) === "") {
            isValid = false;
            $(element).find("[id^=lastNameError]").show();
        }

        if (!util.isValidEmail(email)) {
            isValid = false;
            $(element).find("[id^=emailError]").show();
        }

        if (!util.isValidEmailLength(email, emailMaxLength)) {
            isValid = false;
            $(element).find("[id^=emailMaxLengthError]").show();
        }

        if (confirmEmail.length > 0) {
            var confirmEmailValue = confirmEmail.val();

            if (!confirmEmailValue || $.trim(confirmEmailValue) === "") {
                isValid = false;
                $(element).find("[id^=confirmEmailError]").show();
            }

            if (email && confirmEmailValue && email !== confirmEmailValue) {
                isValid = false;
                $(element).find("[id^=emailMismatchError]").show();
                $(element).find("[id^=confirmEmailMismatchError]").show();
            }
        }

        if (isValid) {
            var dataLayerEvent = {
                event: "inviteCaregiver",
                "ctaLink": $(this).text().trim()
            };
            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);

            undoEditMemberFieldHighlights();
            $("#javascriptValidationSummary").remove();
            var model = createCaregiverObject(false, element);

            $.ajax({
                url: window.location.href,
                type: "POST",
                dataType: "json",
                context: this,
                data: {
                    scController: "editCaregiver",
                    scAction: "AddNewCaregiver",
                    model: model,
                    __RequestVerificationToken: $("#editCaregiverForm input[name=__RequestVerificationToken]").val()
                },
                success: function (data) {
                    if (data.IsValid) {
                        location.reload();
                        //$('#caregiverSuccessMessage').show();
                        //$('html,body').animate({ scrollTop: $('#caregiverSuccessMessage').top }, 'slow');
                    } else {
                        $(data.ErrorMessages).each(function (key, element) {
                            $("#" + element.ErrorMessageId).show();
                        });

                        createValidationSummary("editCaregiverForm", data.ErrorMessages.length);
                        highlightEditMemberFields();

                        $(data.ErrorMessages).each(function (index, element) {
                            if (!element.ErrorMessageId) {
                                $("<li>" + element.ErrorMessageText + "</li>").appendTo("#javascriptValidationUl");
                            }
                        });
                        $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").top }, "slow");
                    }
                },
                error: function (data) {
                    console.log("whoops", data);
                }
            });
        } else {
            highlightEditMemberFields();
            createValidationSummary("editCaregiverForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
    });

    $(".caregiver-box-remove").on("click", function (e) {
        e.preventDefault();

        var element = $(this).parent().parent();
        var fname = $(this).closest(".preference-box").find(".fname").val();
        var lname = $(this).closest(".preference-box").find(".lname").val();
        // setup event handlers for the dialog buttons
        $("#removeCaregiverLabelYes").on("click", function () {
            var model = createCaregiverObject(true, element);
            model.CaregiversToRemove[0].FirstName = fname;
            model.CaregiversToRemove[0].LastName = lname;

            $.ajax({
                url: window.location.href,
                type: "POST",
                dataType: "json",
                context: this,
                data: {
                    scController: "editCaregiver",
                    scAction: "RemoveCaregiver",
                    model: model,
                    __RequestVerificationToken: $("#editCaregiverForm input[name=__RequestVerificationToken]").val()
                },
                success: function (data) {
                    $("#removeCaregiverConfirmation").modal("hide");
                    if (data.IsValid) {
                        location.reload();
                    } else {
                        $(data.ErrorMessages).each(function (key, element) {
                            $("#" + element.ErrorMessageId).show();
                        });

                        createValidationSummary("editCaregiverForm", data.ErrorMessages.length);
                        highlightEditMemberFields();

                        $(data.ErrorMessages).each(function (index, element) {
                            if (!element.ErrorMessageId) {
                                $("<li>" + element.ErrorMessageText + "</li>").appendTo("#javascriptValidationUl");
                            }
                        });
                        $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
                    }
                },
                error: function (data) {
                    $("#removeCaregiverConfirmation").modal("hide");
                    location.reload();
                }
            });
        });

        $("#removeCaregiverLabelNo").on("click", function () {
            $("#removeCaregiverConfirmation").modal("hide");
        });

        displayModal("removeCaregiverConfirmation");
    });

    // update the displayed email address in the Member Demographic Informational module
    if ($(".current-email-address").length > 0) {
        if (updatedEmailAddress !== "") {
            $(".current-email-address a").attr("href", "mailto:" + updatedEmailAddress);
            $(".current-email-address a").html(updatedEmailAddress);
        }
    }

    // handle submit button click for edit address (residential and mailing)
    $("#btnAddressUpdate").on("click", function () {
        undoEditMemberFieldHighlights();

        // hide alert message if present
        $("#updateAddress").find(".alert").hide();

        var isValid = true;
        $("span.field-validation-error.form-error-hint").hide();

        var isAddressBeingUpdated = $("#IsAddressBeingUpdated").is(":checked");
        var isMailingAddressBeingUpdated = $("#IsMailingAddressBeingUpdated").is(":checked");

        if (isAddressBeingUpdated) {
            var address1Val = $("#Address1").val().trim();
            var cityVal = $("#City").val().trim();
            var zipVal = $("#Zip").val().trim();
            var countyVal = $("#County").val().trim();
            var addressEffectiveDate = $("#AddressEffectiveDate").val().trim();
            var minDate = "1/1/0001 12:00:00 AM";

            if (address1Val == "") {
                isValid = false;
                $("#NoAddress1Entered").show();
            } else if (util.isPostOfficeBox(address1Val)) {
                isValid = false;
                $("#POBoxNotAllowed").show();
            }
            if (cityVal == "") {
                isValid = false;
                $("#NoCityEntered").show();
            }
            if (zipVal == "") {
                isValid = false;
                $("#NoZipCodeEntered").show();
            } else if (!util.isValidUSZipCode(zipVal)) {
                isValid = false;
                $("#ZipCodeInvalid").show();
            }
            if (countyVal == "") {
                isValid = false;
                $("#NoCountySelected").show();
            }
            if (addressEffectiveDate == "" || addressEffectiveDate == minDate) {
                isValid = false;
                $("#NoAddressEffectiveDateSelected").show();
            }
        }

        if (isMailingAddressBeingUpdated) {
            var mailingAddress1Val = $("#MailingAddress1").val().trim();
            var mailingCityVal = $("#MailingCity").val().trim();
            var mailingStateVal = $("#MailingState").val().trim();
            var mailingZipVal = $("#MailingZip").val().trim();
            var mailingAddressEffectiveDate = $("#MailingAddressEffectiveDate").val().trim();

            if (mailingAddress1Val == "") {
                isValid = false;
                $("#NoMailingAddress1Entered").show();
            }
            if (mailingCityVal == "") {
                isValid = false;
                $("#NoMailingCityEntered").show();
            }
            if (mailingStateVal == "") {
                isValid = false;
                $("#NoMailingStateSelected").show();
            }
            if (mailingZipVal == "") {
                isValid = false;
                $("#NoMailingZipCodeEntered").show();
            } else if (!util.isValidUSZipCode(mailingZipVal)) {
                isValid = false;
                $("#MailingZipCodeInvalid").show();
            }
            if (mailingAddressEffectiveDate == "") {
                isValid = false;
                $("#NoMailingAddressEffectiveDateEntered").show();
            }
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var yesterday = new Date(today.setDate(today.getDate() - 1));
            var targetDate = new Date(today.setMonth(today.getMonth() + 2));
            var sourceDate = new Date(mailingAddressEffectiveDate);
            if (sourceDate > targetDate) {
                isValid = false;
                $("#MailingAddressEffectiveDateInvalid").show();
            }
            if (sourceDate <= yesterday) {
                isValid = false;
                $("#MailingAddressEffectiveDatePast").show();
            }
        }

        if (!isAddressBeingUpdated && !isMailingAddressBeingUpdated) {
            isValid = false;
            $("#NoAddressSelectedToUpdate").show();
        }

        var password = $("#verify-password-address").val();
        if ($.trim(password) == "") {
            isValid = false;
            $("#PasswordErrorMessageForaddress").show();
        }
        else {
            $("#PasswordErrorMessageForaddress").hide();
        }

        if (isValid) {
            if (isMailingAddressBeingUpdated) {
                $("#confirmationPopup").show();
            } else {
                undoEditMemberFieldHighlights();
                $("#javascriptValidationSummary").remove();
                $("#editAddressForm").submit();
            }
        } else {
            highlightEditMemberFields();
            createValidationSummary("editAddressForm");
            $("html,body").animate({ scrollTop: $("#javascriptValidationSummary").parent().top }, "slow");
        }
        return false;
    });

    $("#updateAddressConfirmBtn").on("click", function (e) {
        undoEditMemberFieldHighlights();
        $("#javascriptValidationSummary").remove();
        $("#editAddressForm").submit();
        $("#confirmationPopup").hide();
    });

    $("#cancelMailChange").on("click", function (e) {
        $("#confirmationPopup").hide();
        $("#editAddressForm").focus();
    });

    // if we're on the member portal page that contains the Update Address form
    if ($("#updateAddress").length > 0) {
        var loadedQuerystring = querystring.parse();
        var showAddressEdit = loadedQuerystring["expandaddress"];
        if (showAddressEdit == "true") {
            expandPanel("#updateAddress");
        }

        var readonlyOnCSS = { background: "#c9c9c9", border: "1px solid #454545" };
        var readonlyOffCSS = { background: "#fff", border: "1px solid #000" };

        // toggle readonly attribute on member portal resident address / mailing address fields based on checkbox state
        var isAddressBeingChanged = $("#IsAddressBeingUpdated").is(":checked");
        ToggleAddressFields(!isAddressBeingChanged);
        var isMailingAddressBeingChanged = $("#IsMailingAddressBeingUpdated").is(":checked");
        ToggleMailingAddressFields(!isMailingAddressBeingChanged);
        $("#sameAsResidentialAddress").prop("disabled", !isMailingAddressBeingChanged);
        $("#MailingAddressEffectiveDate").prop("disabled", !isMailingAddressBeingChanged);

        $("#IsAddressBeingUpdated").on("click", function () {
            var isReadonly = !this.checked;
            ToggleAddressFields(isReadonly);
        });

        $("#IsMailingAddressBeingUpdated").on("click", function () {
            var isReadonly = !this.checked;
            ToggleMailingAddressFields(isReadonly);
            $("#sameAsResidentialAddress").prop("disabled", isReadonly);
            if (isReadonly) {
                $("#sameAsResidentialAddress").prop("checked", false);
                $("#MailingState").parent().find("button").attr("tabindex", -1);
            } else {
                $("#MailingState").parent().find("button").attr("tabindex", 0);
            }
            $("#MailingAddressEffectiveDate").prop("disabled", isReadonly);
        });

        function ToggleAddressFields(isReadonly) {
            // toggle readonly state
            $("#Address1").prop("readonly", isReadonly);
            $("#Address2").prop("readonly", isReadonly);
            $("#City").prop("readonly", isReadonly);
            $("#Zip").prop("readonly", isReadonly);
            $("#County1").prop("readonly", isReadonly);
            $("#County2").prop("readonly", isReadonly);
            $("#AddressEffectiveDate1").prop("readonly", isReadonly);
            $("#AddressEffectiveDate2").prop("readonly", isReadonly);
            $("#effectiveDate1").prop("disabled", isReadonly);
            $("#effectiveDate2").prop("disabled", isReadonly);

            // toggle style to appear enabled/disabled
            var styleToApply;
            if (isReadonly) {
                styleToApply = readonlyOnCSS;
            } else {
                styleToApply = readonlyOffCSS;
            }
            $("#Address1").css(styleToApply);
            $("#Address2").css(styleToApply);
            $("#City").css(styleToApply);
            $("#Zip").css(styleToApply);
            $("#AddressEffectiveDate1").css(styleToApply);
            $("#AddressEffectiveDate2").css(styleToApply);
            $("#effectiveDate1").css(styleToApply);
            $("#effectiveDate2").css(styleToApply);
        }

        function ToggleMailingAddressFields(isReadonly) {
            // toggle readonly state
            $("#MailingAddress1").prop("readonly", isReadonly);
            $("#MailingAddress2").prop("readonly", isReadonly);
            $("#MailingCity").prop("readonly", isReadonly);
            $("#MailingState").prop("readonly", isReadonly);
            $("#MailingState").prop("disabled", isReadonly);
            $("[data-id=MailingState]").prop("disabled", isReadonly); // this is a button, so toggle disabled
            $("#MailingZip").prop("readonly", isReadonly);
            if (!isReadonly) {
                $("[data-id=MailingState]").removeClass("disabled");
            }

            // toggle style to appear enabled/disabled
            var styleToApply;
            if (isReadonly) {
                styleToApply = readonlyOnCSS;
            } else {
                styleToApply = readonlyOffCSS;
            }
            $("#MailingAddress1").css(styleToApply);
            $("#MailingAddress2").css(styleToApply);
            $("#MailingCity").css(styleToApply);
            $("#MailingState").css(styleToApply);
            $("[data-id=MailingState]").css(styleToApply);
            $("#MailingZip").css(styleToApply);
        }

        // set AddressEffectiveDate based on selected radio button
        $("input[name='AddressEffectiveDateChoice']").change(function () {
            var d = $("input[name='AddressEffectiveDateChoice']:checked").val();
            $("#AddressEffectiveDate").val(d);
        });

        // if user selects option to copy residential address to mailing address
        // set fields to readonly and apply a style that makes them appear disabled
        // (can't disable them because then the data won't post)
        $("#sameAsResidentialAddress").on("click", function (e) {
            var isReadonly = this.checked;
            ToggleMailingAddressFields(isReadonly);
            // copy values from residential address
            if (isReadonly) {
                $("#MailingAddress1").val($("#Address1").val());
                $("#MailingAddress2").val($("#Address2").val());
                $("#MailingCity").val($("#City").val());
                var stateValue = $("#State").val();
                $("#MailingState").val(stateValue);
                $("#MailingState").prop("disabled", false);
                $("[data-id=MailingState]").find(".filter-option-inner-inner").eq(0).text(stateValue);
                $("#MailingZip").val($("#Zip").val());
                $("#MailingCounty").val($("#County").val());
            }
        });

        // attach to onblur of resident address zip code field - check for split zip
        $("#Zip").blur(function () {
            // reset County to original, and county radio buttons
            $("#County").val($("#OriginalCounty").val());
            $("#county1").prop("checked", false);
            $("#county2").prop("checked", false);
            $("#btnAddressUpdate").prop("disabled", true);
            var zip = $("#Zip").val();
            $.ajax({
                url: "/api/portalzipcode/" + zip,
                type: "GET",
                dataType: "json",
                context: this,
                success: function (data) {
                    var json = JSON.parse(data);
                    var originalCounty = $("#OriginalCounty").val().toUpperCase();
                    var isValidCountyPresent = false;
                    $("#ZipCodeInvalid").hide();
                    $("#ZipCodeOutsideOfCountyErrorText").hide();
                    $("#CountyInvalidText").hide();
                    $("#splitZipCountyDiv").hide();
                    var numberOfCounties = json.Counties.length;
                    if (numberOfCounties == 0) {
                        // if no counties were returned, this must be an invalid zip
                        $("#ZipCodeInvalid").show();
                    } else {
                        // else one or more counties, check if valid county present
                        $("#County").val("");
                        for (var i = 0; i < numberOfCounties; i++) {
                            var county = json.Counties[i].Text.toUpperCase();
                            if (county == originalCounty) {
                                isValidCountyPresent = true;
                            }
                        }
                        if (isValidCountyPresent) {
                            // valid county present
                            if (numberOfCounties == 1) {
                                // if only one county then we're good to go
                                $("#County").val(originalCounty);
                                $("#btnAddressUpdate").prop("disabled", false);
                            } else {
                                // else more than one county available, so allow selection
                                $("#lblCounty1").text(json.Counties[0].Text);
                                $("#lblCounty2").text(json.Counties[1].Text);
                                $("#splitZipCountyDiv").show();
                            }
                        } else {
                            // else no valid county available
                            $("#ZipCodeOutsideOfCountyErrorText").show();
                        }
                    }
                    createValidationSummary("editAddressForm");
                },
                error: function (data) {
                    console.log("whoops", data);
                }
            });
        });

        // when a split-zip radio button is selected, set hidden County field
        $("#county1").on("click", function () {
            if (this.checked) {
                validateCountySelection($("#lblCounty1").text().toUpperCase());
            }
        });
        $("#county2").on("click", function () {
            if (this.checked) {
                validateCountySelection($("#lblCounty2").text().toUpperCase());
            }
        });

        // validate selected county
        function validateCountySelection(selectedCounty) {
            var originalCounty = $("#OriginalCounty").val().toUpperCase();
            if (selectedCounty != originalCounty) {
                $("#btnAddressUpdate").prop("disabled", true);
                $("#CountyInvalidText").show();
            } else {
                $("#btnAddressUpdate").prop("disabled", false);
                $("#CountyInvalidText").hide();
            }
            createValidationSummary("editAddressForm");
            $("#County").val(selectedCounty);
        }
    }
});
